// #ux-redesign-start: LoadingOverlay primitive (Paso 5 - Sistema de carga unificado)
// Overlay con Spinner del DS. Reemplaza al LoadingGlobal legacy (fondo blanco
// hardcoded que rompe dark mode) y al patrón ad-hoc de poner una <div>
// position:fixed con un loader.
//
// MODOS
//   - fullscreen (default): position fixed, cubre la app entera, fondo opaco
//     theme-aware. Para el splash inicial de App.js, cambios de sesión, etc.
//   - contained: position absolute, se posiciona sobre el contenedor padre
//     (que debe tener position relative). Fondo semitransparente + blur.
//
// USO
//   <LoadingOverlay />                                            // fullscreen
//   <LoadingOverlay label={t('loading')} />                        // con texto
//   <div style={{ position: 'relative' }}>
//     <LoadingOverlay mode="contained" />
//     <Contenido />
//   </div>
//
// PORTABILIDAD: trasplantable a Web-Patients sin cambios.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';
import Spinner from './Spinner';

const LoadingOverlay = ({
  mode = 'fullscreen',
  size = 'lg',
  label = null,
  ariaLabel,
  className = '',
}) => (
  <div
    className={`ds-loading-overlay ds-loading-overlay--${mode} ${className}`.trim()}
    role="status"
    aria-live="polite"
    aria-label={ariaLabel || label || 'Laden…'}
  >
    <Spinner size={size} ariaLabel="" />
    {label && <span className="ds-loading-overlay__text">{label}</span>}
  </div>
);

LoadingOverlay.propTypes = {
  mode: PropTypes.oneOf(['fullscreen', 'contained']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  label: PropTypes.node,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
};

export default LoadingOverlay;
// #ux-redesign-end
